import { usePostHogFeatureFlag } from '@/hooks/usePostHogFeatureFlag';

/**
 * Gates **location overview** beta health columns (`showBetaLaksvelColumn`, `showWoundColumn`)
 * via the `health-module` PostHog flag and FISH_HEALTH.MIN.
 *
 * Cage-level Health routes use bioscope version + license instead (see `HealthLayout`).
 * Per-pen overview cells also use `overviewHealthColumnVisibility` and the `shouldShow*` helpers.
 */
export function useHealthModuleEnabled(hasAccessToFishHealth: boolean): boolean {
    const { enabled: healthModuleFlagEnabled } = usePostHogFeatureFlag('health-module');

    return healthModuleFlagEnabled && hasAccessToFishHealth;
}
